module.exports = __webpack_public_path__ + "img/des_paint_2.da69d611.jpg";